import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/obrazky/homepage_photo.png'
import _imports_1 from '../../public/obrazky/sponzori/TRASKO_logo+pas__pos__sRGB.jpg'


const _withScopeId = n => (_pushScopeId("data-v-f05f9fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-col tablet:flex-row tablet:h-[calc(100vh-60px)] tablet:min-h-[600px] bg-greenLight overflow-hidden",
  id: "homepageHeading"
}
const _hoisted_2 = { class: "bg-greenLight text-greenDarkest flex justify-center flex-col h-full tablet:w-1/2 laptop:w-1/3" }
const _hoisted_3 = { class: "flex flex-col space-y-5 items-center p-14" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-greenDarkest font-semibold text-3xl" }, "Vítejte", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-greenDarkest text-lg w-72" }, "na stránkách oddílu moderní gymnastiky", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-primary font-bold text-5xl tablet:text-6xl mt-20 mb-32 pt-10 w-96" }, "SK TRASKO VYŠKOV", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: " ",
  class: "object-cover w-full tablet:w-1/2 tablet:h-[100vh-60px] laptop:w-2/3 transition-transform duration-200",
  id: "homeImage"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<section class=\"hide-animate\" data-v-f05f9fb8><div class=\"bg-white p-[90px] space-y-6 px-[10%] flex flex-col tablet:flex-row tablet:justify-between tablet:space-y-0 laptop:px-[15%]\" data-v-f05f9fb8><div class=\"bg-orangeLight text-orangeDark p-5 px-10 tablet:w-[30%] flex justify-center flex-col\" data-v-f05f9fb8>Trénujeme moderní a estetickou skupinovou gymnastiku</div><div class=\"bg-orangeLight text-orangeDark p-5 px-10 tablet:w-[30%] flex justify-center flex-col\" data-v-f05f9fb8>Jezdíme na závody po celé České republice i mimo ní</div><div class=\"bg-orangeLight text-orangeDark p-5 px-10 tablet:w-[30%] flex justify-center flex-col\" data-v-f05f9fb8>Kromě závodů pořádáme také každoroční akce jako Akademie a Vánoční besídky</div></div></section>", 1)
const _hoisted_9 = { class: "bg-grayLight w-full py-8 pl-12 pr-8 tablet:p-20 tablet:px-32 flex flex-col items-start desktop:items-center desktop:flex-row desktop:justify-between" }
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " - ", -1))
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " - ", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "max-w-[400px] w-[100%] tablet:max-w-[600px] desktop:max-w-[50%] desktop:w-[50%] my-10 desktop:my-0 flex justify-end"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "hide-animate" }
const _hoisted_18 = { class: "hide-animate" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-5 tablet:px-10 flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.trasko.cz/",
    target: "_blank",
    class: "hover:scale-105 transition"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "h-[140px] laptop:h-[200px]"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[90%] text-blue pb-10 text-sm tablet:w-[60%]" }, "Firma TRASKO, a.s. finančně zabezpečuje chod oddílu po celou dobu jeho působení, a dále oddílu vypomáhá také materiálně-technickým zabezpečením všech pořádaných akcí."),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center laptop:flex-row" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.vyskov-mesto.cz/",
      target: "_blank",
      class: "flex justify-center laptop:hover:scale-105 transition"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-[15vw] tablet:h-[100px]",
        src: "/obrazky/sponzori/vyskov_logo_MV_web.jpg"
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.jmk.cz/",
      target: "_blank",
      class: "flex justify-center laptop:hover:scale-105 transition"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-[15vw] tablet:h-[100px]",
        src: "/obrazky/sponzori/Logotyp_jihomoravsky_kraj_RGB.jpg"
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://nsa.gov.cz/",
      target: "_blank",
      class: "flex justify-center laptop:hover:scale-105 transition"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "h-[15vw] tablet:h-[100px]",
        src: "/obrazky/sponzori/Narodni%20sportovni%20agentura_logo%20rgb.jpg"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[90%] text-blue pb-10 text-sm tablet:w-[60%]" }, "Činnost oddílu SK TRASKO Vyškov, z.s. a akce jím realizované jsou finančně podporovány městem Vyškov, Jihomoravským krajem a Národní sportovní agenturou."),
  /*#__PURE__*/_createElementVNode("div", { class: "flex block flex-grow" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[100px]" }, null, -1))

import CustomButton from "@/components/Base/CustomButton.vue";
  import MyCarousel from "@/components/HomePage/MyCarousel.vue";
  import SectionBoxHomepage from "@/components/HomePage/SectionBoxHomepage.vue";
  import {ref} from "vue";
  import aktuality, {aktualityImage} from "../../public/data/aktuality";

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const aktualityRef = ref<HTMLElement | null>(null);

  const showAktualityImage = Boolean(aktualityImage);

  function scrollToAktuality(){
    // document.getElementById('aktuality')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    aktualityRef.value?.scrollIntoView({behavior: "smooth", block: "start"});
  }

  let sections = document.getElementsByTagName('section')
  window.onscroll = () => {
    for(let item of sections){
      let top =window.scrollY;
      let offset = item.offsetTop;
      let height = item.offsetHeight;
      let relativeOffset = window.innerHeight * 0.8;

      if(top >= (offset - relativeOffset) && top < offset + height){
        item.classList.add('show-animate')
      }
      // else{
      //   item.classList.remove('show-animate')
      // }
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createVNode(CustomButton, {
            class: "mt-56 hover:scale-105 transition duration-200",
            value: "Aktuality",
            "bg-color": "bg-orange",
            "text-color": "text-white",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToAktuality()))
          })
        ])
      ]),
      _hoisted_7
    ]),
    _hoisted_8,
    _createElementVNode("section", {
      id: "aktualityRef",
      class: "hide-animate scroll-mt-32",
      ref_key: "aktualityRef",
      ref: aktualityRef
    }, [
      _createVNode(SectionBoxHomepage, {
        id: "aktuality",
        "section-name": "Aktuality",
        "text-color": "text-orange"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", {
                class: _normalizeClass(["list-disc text-green text-lg", {'desktop:w-[50%]': _unref(showAktualityImage)}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aktuality), (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "p-2 text-left",
                    key: item.title
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.title), 1),
                    (item.PDF)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_11,
                          _createElementVNode("a", {
                            href: 'PDFs/aktuality/' + item.PDF,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "text-green hover:text-greenDark"
                          }, _toDisplayString(item.PDFtitle), 9, _hoisted_12)
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.link)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_13,
                          _createElementVNode("a", {
                            href: item.link,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "text-green hover:text-greenDark"
                          }, _toDisplayString(item.linkTitle), 9, _hoisted_14)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 2),
              (_unref(showAktualityImage))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: 'obrazky/aktuality/' + _unref(aktualityImage),
                      alt: "",
                      class: "w-full desktop:w-[80%]"
                    }, null, 8, _hoisted_16)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 3
      })
    ], 512),
    _createElementVNode("section", _hoisted_17, [
      _createVNode(MyCarousel)
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createVNode(SectionBoxHomepage, {
        "section-name": "Sponzoři",
        "text-color": "text-blue"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _hoisted_19
          ])
        ]),
        _: 3
      })
    ]),
    _hoisted_20
  ], 64))
}
}

})